import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@/feature/utils';

import { Committee, CommitteeRequest } from './CommitteeTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Committee>>('/author/committee/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Committee>(`/author/committee/${id}`).then(getData);
}

export function edit(id: Id, request: CommitteeRequest) {
  return axios.put<Committee>(`/author/committee/${id}`, request).then(getData);
}

export function create(request: CommitteeRequest) {
  return axios.post<Committee>(`/author/committee`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/committee/${id}`).then(getData);
}
